import { Link } from "react-router-dom";

export default function ArticleHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[500px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20soft%20terracotta%20sand%20and%20cream%20color%20blocks%2C%20elegant%20gradient%20texture%2C%20sophisticated%20art%20gallery%20backdrop%2C%20subtle%20grain%20and%20paper%20texture%2C%20no%20text%20or%20objects&width=1800&height=750&seq=arthero-v3-main&orientation=landscape"
        alt="Guia Completo do Hoobuy Spreadsheet"
        title="Guia Completo do Hoobuy Spreadsheet 2026"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white leading-tight">
          Guia Completo do Hoobuy Spreadsheet
        </h1>
        <p className="mt-4 text-base md:text-lg text-white/80 max-w-[640px] mx-auto font-serif italic">
          Atualizado para 2026
        </p>
        <p className="mt-3 text-sm text-white/65 max-w-[600px] mx-auto">
          Saiba como economizar tempo e dinheiro encontrando os melhores produtos em um só lugar
        </p>
        <div className="mt-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-foreground-950 font-semibold text-sm rounded-full whitespace-nowrap cursor-pointer hover:bg-white/90 transition-all duration-300"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line"></i>
            </div>
            Voltar ao Início
          </Link>
        </div>
      </div>
    </section>
  );
}